import { useContext } from "react";
import { UNSAFE_RouteContext } from "react-router-dom";
import { isTruthy } from "shared/utils/utils";

export const useRoutePathTemplate = () => {
  const routeContext = useContext(UNSAFE_RouteContext);
  return `/${routeContext.matches
    .map((m) => m.route.path)
    .filter(isTruthy)
    .join("/")}`;
};
